@import 'styles/mixins';
@import 'styles/variables';

.pill {
  @include lg-regular;
  background: var(--neutral-5);
  border-radius: 50px;
  color: #262b35;
  padding: 0px 4px 1px 8px;
  margin-right: 4px;
  text-wrap: nowrap;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
  display: inline;

  .removeTagBtn {
    cursor: pointer;
    color: var(--neutral-30);

    width: 12px;
    height: 12px;
    padding: 2px;
    box-sizing: content-box;
    transform: translateY(2px);
    vertical-align: text-top;
    margin-top: 1px;
    border-radius: 24px;

    svg {
      vertical-align: top;
    }

    &:hover {
      color: var(--neutral-50);
      background: var(--neutral-5);
    }
  }
}
